<template>
  <div class="form-group form-group-border-bottom d-flex flex-column" dir="rtl" style="min-height: 33px;">
    <input type="hidden" :name="name" :value="parsedValue" />
    <button
      type="button"
      class="d-flex flex-row align-items-center padding-10 pointer position-relative date-field-trigger"
      :aria-expanded="datePickerVisible ? 'true' : 'false'"
      aria-haspopup="dialog"
      :aria-controls="datepickerid"
      :aria-label="dateTriggerLabel"
      @click="toggleDatePicker"
    >
      <SvgImage :src="field.icon" class="position-relative " style="top:-2px" aria-hidden="true" />
      <span class="flex-grow-1 text-right date-field-value cef">{{parsedValue || label}}</span>
      <CaretComponent :open="datePickerVisible" class="date-field-caret" aria-hidden="true" />
    </button>
    <div v-show="datePickerVisible" class="w-100 " id="collapseDatepicker">
      <div class="card card-body margin-top-0 bg-inherit noborder">
        <div class="d-flex flex-row">
          <button
            type="button"
            class="f15-l18-m df22-l32-m d-flex flex-row pointer nowrap date-quick-option"
            v-for="(elm,idx) in options"
            :key="idx"
            @click="selectOption(elm,idx)"
          >
            <span class="padding-5">{{elm.text}}</span>
            <span v-show="idx<options.length-1" aria-hidden="true">|</span>
          </button>
        </div>
        <div
          :id="datepickerid"
          class="date-picker-calendar"
          style="display:block;"
          tabindex="-1"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
/* global $ */
import SvgImage from "@/components/generic/SvgImage";
import CaretComponent from "@/components/CaretComponent";
export default {
  components: {
    SvgImage,
    CaretComponent
  },
  props: ["label", "type", "name", "value", "field"],
  data() {
    return {
      fieldValue: "",
      fieldValueIsDate: true,
      popupContent: {},
      options: [],
      datePickerVisible: false,
      datepickerid: 'datepicker',
      rtlArrowKeyHandler: null,
    }
  },
  mounted() {
    this.datepickerid = 'datepicker' + this._.uid;
    if (this.value) {
      this.fieldValue = this.value.split("/").reverse().join("-");
    }
    this.popupContent = this.field.popup_content;
    if (this.popupContent) {
      this.options = this.field.popup_content[0].options;
    }

    this.setupDatePicker();

  },
  watch: {
    datePickerVisible() {
      this.$nextTick(() => this.enhanceDatepickerKeyboardAccess());
    }
  },
  unmounted() {
    this.unbindRtlArrowKeyFix();
    $("#" + this.datepickerid).datepicker('destroy');
  },
  methods: {
    async setupDatePicker() {
      const this$ = this;
      await this.$nextTick();
      $("#" + this.datepickerid).datepicker({
        autoClose: true,
        format: "dd/mm/yyyy",
        language: "he",
        rtl: true,
        todayBtn: false,
        todayHighlight: true,
        startDate: 'tomorrow',
        container: "#" + this.datepickerid
      })
        .on('changeDate', function () {
          this$.fieldValueIsDate = true;
          this$.fieldValue = $('#' + this$.datepickerid).datepicker('getFormattedDate');
          this$.toggleDatePicker();
          this$.$emit("change");
        })
        .on('changeMonth changeYear', function () {
          this$.$nextTick(() => this$.enhanceDatepickerGridRoles());
        });
      if (this.value) {
        $("#" + this.datepickerid).datepicker('update', this.value);
      }
      this.bindRtlArrowKeyFix();
      this.enhanceDatepickerKeyboardAccess();
    },
    bindRtlArrowKeyFix() {
      const el = document.getElementById(this.datepickerid);
      if (!el || this.rtlArrowKeyHandler) {
        return;
      }
      this.rtlArrowKeyHandler = (e) => {
        if (this._remappingArrowKey) {
          return;
        }
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        const remappedKey = e.key === 'ArrowLeft' ? 'ArrowRight' : 'ArrowLeft';
        const remappedCode = remappedKey === 'ArrowLeft' ? 37 : 39;
        const remapped = new KeyboardEvent('keydown', {
          key: remappedKey,
          code: remappedKey,
          keyCode: remappedCode,
          which: remappedCode,
          bubbles: true,
          cancelable: true,
        });
        this._remappingArrowKey = true;
        el.dispatchEvent(remapped);
        this._remappingArrowKey = false;
      };
      el.addEventListener('keydown', this.rtlArrowKeyHandler, true);
    },
    unbindRtlArrowKeyFix() {
      const el = document.getElementById(this.datepickerid);
      if (el && this.rtlArrowKeyHandler) {
        el.removeEventListener('keydown', this.rtlArrowKeyHandler, true);
      }
      this.rtlArrowKeyHandler = null;
    },
    enhanceDatepickerKeyboardAccess() {
      const $el = $('#' + this.datepickerid);
      if (!$el.length) {
        return;
      }
      $el.attr({
        tabindex: this.datePickerVisible ? '0' : '-1',
        role: 'application',
        'aria-label': 'לוח שנה לבחירת תאריך. השתמשו בחיצים לניווט, Enter לבחירה',
      });
      this.enhanceDatepickerGridRoles();
    },
    enhanceDatepickerGridRoles() {
      const $el = $('#' + this.datepickerid);
      const $table = $el.find('.datepicker-days table');
      if (!$table.length) {
        return;
      }
      $table.attr('role', 'grid');
      $table.find('th.dow').attr('role', 'columnheader');
      $table.find('td.day').attr('role', 'gridcell');
    },
    selectOption(elm) {
      this.fieldValue = elm.val;
      this.datePickerVisible = false;
    },
    toggleDatePicker() {
      this.datePickerVisible = !this.datePickerVisible;
    }
  },
  computed: {
    dir() {
      return "rtl";
    },
    parsedValue() {
      if (this.fieldValueIsDate) {
        return this.fieldValue.split("-").reverse().join("/");
      }
      return this.fieldValue;
    },
    placeholder() {
      if (!this.field) return "";
      if (this.field?.default_text) return this.field?.default_text.text;
      return "";
    },
    title() {
      try {
        return this.popupContent[0].title;
      } catch (e) {
        return '';
      }
    },
    dateTriggerLabel() {
      const current = this.parsedValue || this.label;
      return `בחירת תאריך, ${current}`;
    }
  }
}
</script>
<style scoped>
.date-field-trigger {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 33px;
  box-sizing: border-box;
  border: none;
  background: transparent;
  font: inherit;
  cursor: pointer;
  text-align: inherit;
  color: inherit;
}

.date-field-value {
  border: 0;
  background: transparent;
  padding: 0;
  line-height: inherit;
  color: inherit;
}

.date-field-caret {
  flex-shrink: 0;
}

.date-quick-option {
  border: none;
  background: transparent;
  font: inherit;
  cursor: pointer;
  color: inherit;
}

.date-picker-calendar:focus {
  outline: none;
}

.date-picker-calendar:focus-visible {
  outline: 2px solid #ef3d49;
  outline-offset: 2px;
}
</style>
